import { useMemo } from 'react';
import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useRequestedAppointmentTypes = (scheduleRequests: ScheduleRequest[] | undefined) => {
  const requestedAppointmentTypeIds = useMemo(
    () =>
      scheduleRequests?.reduce((acc, request) => {
        if (request.appointmentTypeId) {
          acc.push(request.appointmentTypeId);
        }
        return acc;
      }, [] as string[]) || [],
    [scheduleRequests]
  );

  const requestedAppointmentTypesQueries = SchedulerV3.Queries.useGetAppointmentTypeQueries(
    requestedAppointmentTypeIds.map((id) => ({ request: { appointmentTypeId: id } }))
  );

  const requestedAppointmentTypes = useMemo(() => {
    if (!requestedAppointmentTypeIds.length) return [];
    return requestedAppointmentTypesQueries
      .map((query) => query.data?.appointmentType)
      .filter((data): data is NonNullable<typeof data> => data !== undefined);
  }, [requestedAppointmentTypesQueries, requestedAppointmentTypeIds]);

  return { requestedAppointmentTypesQueries, requestedAppointmentTypes };
};
